// extracted by mini-css-extract-plugin
module.exports = {"avatar":"DoctorAvatar_avatar__KhHyj"};